import { Viewer } from "@toast-ui/react-editor";
import Popup from "@Views/comp/Popup";
import { callService } from "@Views/utils/ServiceUtils";
import { useEffect, useRef, useState } from "react";

const Footer = ({ getMsg }: any) => {
    const msg = getMsg();

    const ctacIdPopupRef: any = useRef();
    const [popupContent, setPopupContent] = useState<any>({});
    const [sdOapiSvcCtacMList, setSdOapiSvcCtacMList] = useState<any>();

    const openPopup = (ctacId: string) => {
        for (const item of sdOapiSvcCtacMList) {
            if (item['ctacId'] === ctacId) {
                setPopupContent({ ctacCtnt: item['ctacCtnt'], title: msg['toS' + item['ctacId']] });
                ctacIdPopupRef['current'].isOpen(true);
                return;
            }
        }
    }

    const OSUOA02R01 = async () => {
        const res = await callService('OSUOA02R01');
        setSdOapiSvcCtacMList(res['sdOapiSvcCtacMList']);
    }
    useEffect(() => {
        OSUOA02R01();
    }, [])

    return (
        <>
            <Popup title={popupContent['title']} className="modal-dialog-scrollable modal-lg modal-dialog-terms" ref={ctacIdPopupRef}>
                <div className="modal-pre-body">
                    <div className="terms-intro">
                        <div className="headline">{msg['toSPopupHeadLine1']}</div>
                        <p>{msg['toSPopupHeadLine2']}<br />{msg['toSPopupHeadLine3']}</p>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="modal-terms">
                        <div className="terms-doc" tabIndex={-1}>
                            {popupContent['ctacCtnt'] && <Viewer initialValue={popupContent['ctacCtnt']} key={popupContent['ctacCtnt']} />}
                        </div>
                    </div>
                </div>
                <div className="modal-foot">
                    <div className="btn-group btn-group-right">
                        <button type="button" className="btn btn-popup positive" onClick={() => { ctacIdPopupRef['current'].isOpen(false); }}>{msg['confirm']}</button>
                    </div>
                </div>
            </Popup>
            <div className="wrap-foot">
                <footer className="footer">
                    <div className="footer-inner clearfix">
                        <div className="footer-logo">
                            <div className="logo">
                                <a href="#" className="logo-link">
                                    <span className="logo-pic"></span>
                                </a>
                            </div>
                        </div>
                        <div className="site-info">
                            <div className="site-detail clearfix">
                                <ul className="site-info-list clearfix">
                                    <li className="site-info-list-item">
                                        <a style={{ color: "#ff6767", fontSize: "15px", fontWeight: "bold" }} tabIndex={0} onClick={() => window.open(msg['privacyGuideLineUrl'])} onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && window.open(msg['privacyGuideLineUrl'])}>{msg['footer']['privacyGuidelines']}</a>
                                    </li>
                                    <li className="site-info-list-item">
                                        <a tabIndex={0} onClick={() => openPopup('1')} onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && openPopup('1')}>{msg['footer']['termsOfUse']}</a>
                                    </li>
                                </ul>
                                <div className="site-link">
                                    <div className="btn-group">
                                        <a className="btn btn-sm btn-gray-outline" tabIndex={0} onClick={() => window.open('https://ecos.bok.or.kr')} onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && window.open('https://ecos.bok.or.kr')}>{msg['footer']['shortcuts']}</a>
                                    </div>
                                </div>
                            </div>
                            <div className="address-set">
                                <address className="address-detail">
                                    <span>{msg['footer']['address']}</span>
                                    <span>{msg['footer']['tel']}</span>
                                </address>
                                <p className="copy">Copyright Bank Of Korea All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default Footer;